import { ConversationalMMEmbeddedResults } from '@fruitful/conversational-mm';
import { type OnboardingChatResults } from '@fruitful/types';
import { useMemo } from 'react';
import { BodyMediumRegular } from 'smoothie';

import type { ConvMMResults } from './ConversationalMoneyMap';
import { normalizeOnboardingChatResults } from './normalizeOnboardingChatResults';

interface ConversationalMMArtifactProps {
    results: ConvMMResults | OnboardingChatResults;
}

/**
 * Grove preview of the member-app CMM results carousel — renders the real,
 * shared slide content inline (no full-screen takeover, no Cultivating hold,
 * no signup CTAs, no guided tooltips).
 */
export const ConversationalMMArtifact = ({
    results: rawResults,
}: ConversationalMMArtifactProps) => {
    const results = useMemo(
        () => normalizeOnboardingChatResults(rawResults),
        [rawResults],
    );

    if (results == null) {
        return (
            <BodyMediumRegular color="$gray900">
                This thread&apos;s results couldn&apos;t be rendered as the
                member carousel.
            </BodyMediumRegular>
        );
    }

    return <ConversationalMMEmbeddedResults results={results} forceNarrow />;
};
